import React, { Component } from "react";

export default class Tos extends Component {
  render() {
    return (
      <section class="terms-page">
        <div class="container">
          <div class="terms-header">
            <h1>Términos de Servicio</h1>
            <p class="last-updated">
              Última actualización: 5 de diciembre, 2025
            </p>
          </div>

          <div class="terms-content">
            <div class="terms-section">
              <h2>1. Aceptación de los Términos</h2>
              <p>
                Al acceder y utilizar CandyCam ("la Plataforma"), usted acepta
                estar sujeto a estos Términos de Servicio ("Términos"). Si no
                está de acuerdo con alguna parte de estos Términos, no podrá
                acceder al servicio.
              </p>
            </div>

            <div class="terms-section">
              <h2>2. Definiciones</h2>
              <ul>
                <li>
                  <strong>Plataforma:</strong> El servicio de streaming en vivo
                  CandyCam.
                </li>
                <li>
                  <strong>Usuario:</strong> Persona que accede y utiliza la
                  Plataforma.
                </li>
                <li>
                  <strong>Creador:</strong> Usuario que transmite contenido en
                  vivo.
                </li>
                <li>
                  <strong>Espectador:</strong> Usuario que visualiza
                  transmisiones.
                </li>
                <li>
                  <strong>Coins:</strong> Moneda virtual de la Plataforma.
                </li>
                <li>
                  <strong>Gemas:</strong> Regalos recibido por los usuarios.
                </li>
              </ul>
            </div>

            <div class="terms-section">
              <h2>3. Registro y Cuenta</h2>
              <h3>3.1. Requisitos de Edad</h3>
              <p>
                Debe tener al menos 18 años de edad para utilizar la Plataforma.
                Al registrarse, declara y garantiza que cumple con este
                requisito de edad.
              </p>

              <h3>3.2. Información de la Cuenta</h3>
              <p>
                Es responsable de mantener la confidencialidad de su cuenta y
                contraseña, y de restringir el acceso a su dispositivo. Acepta
                la responsabilidad por todas las actividades que ocurran bajo su
                cuenta.
              </p>

              <h3>3.3. Cuentas Múltiples</h3>
              <p>
                No está permitido crear múltiples cuentas para evadir
                suspensiones, prohibiciones o para cualquier actividad
                fraudulenta.
              </p>
            </div>

            <div class="terms-section">
              <h2>4. Contenido y Conducta del Usuario</h2>

              <div class="warning-box">
                <p>
                  <strong>Contenido Prohibido:</strong> Está estrictamente
                  prohibido transmitir, compartir o promover contenido que:
                </p>
                <ul>
                  <li>Sea ilegal o fomente actividades ilegales</li>
                  <li>
                    Contenga material sexualmente explícito sin etiqueta de
                    contenido para adultos
                  </li>
                  <li>Promueva violencia, odio o discriminación</li>
                  <li>
                    Infrinja derechos de propiedad intelectual de terceros
                  </li>
                  <li>Contenga malware, virus o intentos de phishing</li>
                  <li>Incluya apuestas o juegos de azar ilegales</li>
                </ul>
              </div>

              <h3>4.1. Derechos sobre el Contenido</h3>
              <p>
                Usted conserva todos los derechos de propiedad intelectual sobre
                el contenido que transmite. Sin embargo, al transmitir en
                CandyCam, nos otorga una licencia mundial, no exclusiva y
                gratuita para transmitir, almacenar y mostrar su contenido en la
                Plataforma.
              </p>

              <h3>4.2. Sistema de Reportes</h3>
              <p>
                Los usuarios pueden reportar contenido que viole estos Términos.
                Nos reservamos el derecho de eliminar contenido y suspender
                cuentas a nuestra discreción.
              </p>
            </div>

            <div class="terms-section">
              <h2>5. Sistema de Monetización</h2>

              <h3>5.1. Coins y Gemas</h3>
              <p>
                Las Coins son la moneda virtual de la Plataforma. Los
                espectadores pueden comprar Coins y enviar Gemas como regalos a
                los creadores durante las transmisiones.
              </p>

              <h3>5.2. Conversión a Dinero Real</h3>
              <p>
                Los creadores pueden convertir las Gemas recibidas en dinero
                real. Los retiros están sujetos a:
              </p>
              <ol>
                <li>Un mínimo de retiro establecido</li>
                <li>Verificación de identidad del creador</li>
                <li>Procesamiento de 3-7 días hábiles</li>
                <li>Deducción de comisiones por transacción</li>
              </ol>

              <h3>5.3. Programa de Referidos</h3>
              <p>
                Los usuarios pueden ganar el 10% de las Gemas recibidas por cada
                creador que inviten a la Plataforma. Esta comisión es de por
                vida y se paga automáticamente.
              </p>
            </div>

            <div class="terms-section">
              <h2>6. Privacidad y Seguridad</h2>

              <h3>6.1. Protección de Datos</h3>
              <p>
                Recopilamos y procesamos datos personales según nuestra{" "}
                <a href="/privacidad" class="legal-link">
                  Política de Privacidad
                </a>
                . Usted puede controlar qué información personal es visible para
                otros usuarios.
              </p>

              <h3>6.2. Tecnología P2P</h3>
              <p>
                Las transmisiones se realizan directamente entre usuarios
                (peer-to-peer) sin pasar por servidores intermedios. Esto
                garantiza mayor privacidad pero depende de la conexión de cada
                usuario.
              </p>

              <h3 id="proteccion-anticapturas">
                6.3. Protección Anticapturas y Limitación de Responsabilidad
              </h3>
              <p>
                <strong>6.3.1. Tecnología de Protección:</strong> Implementamos
                medidas tecnológicas, incluyendo sistemas para prevenir capturas
                de pantalla y grabaciones no autorizadas durante las
                transmisiones en vivo. Estas medidas buscan proteger la
                privacidad de creadores y espectadores.
              </p>

              <p>
                <strong>6.3.2. Naturaleza del Contenido Público:</strong> Los
                usuarios reconocen y aceptan que:
              </p>
              <ul>
                <li>
                  Todo contenido transmitido ó publicado en CandyCam se
                  considera <strong>contenido público</strong>
                </li>
                <li>
                  La transmisión ocurre en un entorno de comunicación{" "}
                  <strong>peer-to-peer (P2P)</strong> entre usuarios
                </li>
                <li>
                  Una vez que el contenido es transmitido ó publicado, CandyCam{" "}
                  <strong>no tiene control absoluto</strong> sobre su
                  distribución posterior
                </li>
              </ul>

              <p>
                <strong>6.3.3. Limitación de Efectividad:</strong> El Usuario
                reconoce que:
              </p>
              <ul>
                <li>
                  Ningún sistema de protección es 100% infalible o invulnerable
                </li>
                <li>
                  Tecnologías externas (software de terceros, hardware de
                  grabación, dispositivos de captura física) pueden eludir
                  nuestras protecciones
                </li>
                <li>
                  La efectividad de las protecciones depende de factores
                  técnicos fuera de nuestro control completo
                </li>
              </ul>

              <p>
                <strong>
                  6.3.4. Exención de Responsabilidad por Capturas:
                </strong>{" "}
                CandyCam <strong>NO se hace responsable</strong> bajo ninguna
                circunstancia por:
              </p>
              <ul>
                <li>
                  Capturas, grabaciones, reproducciones o distribución no
                  autorizada del contenido transmitido ó publicado
                </li>
                <li>
                  Vulneraciones de las protecciones técnicas por parte de
                  terceros
                </li>
                <li>
                  Uso de software, hardware o métodos no autorizados para
                  capturar contenido
                </li>
                <li>
                  Cualquier difusión, redistribución o uso indebido del
                  contenido por espectadores u otros usuarios
                </li>
              </ul>

              <p>
                <strong>6.3.5. Advertencia al compartir su contenido:</strong>{" "}
                Al utilizar CandyCam para transmitir ó publicar su contenido,
                usted:
              </p>
              <ul>
                <li>
                  Reconoce el <strong>riesgo inherente</strong> de que su
                  contenido pueda ser capturado o distribuido sin autorización
                </li>
                <li>
                  Acepta que transmite ó publica contenido bajo su{" "}
                  <strong>propio riesgo y responsabilidad</strong>
                </li>
                <li>
                  Se compromete a{" "}
                  <strong>no transmitir ó publicar contenido</strong> cuya
                  captura o distribución pueda causarle perjuicios
                  significativos
                </li>
              </ul>
            </div>

            <div class="terms-section">
              <h2>7. Limitación de Responsabilidad</h2>

              <p>
                CandyCam se proporciona "tal cual" y "según disponibilidad". No
                garantizamos que:
              </p>
              <ul>
                <li>
                  El servicio estará disponible ininterrumpidamente o libre de
                  errores
                </li>
                <li>Las transmisiones mantendrán siempre la máxima calidad</li>
                <li>Los pagos se procesarán sin demoras</li>
                <li>
                  El contenido de los usuarios será protegido contra copias no
                  autorizadas
                </li>
              </ul>

              <p>
                En ningún caso seremos responsables por daños indirectos,
                incidentales o consecuentes derivados del uso de la Plataforma.
              </p>
            </div>

            <div class="terms-section">
              <h2>8. Modificaciones de los Términos</h2>
              <p>
                Nos reservamos el derecho de modificar estos Términos en
                cualquier momento. Las modificaciones entrarán en vigor
                inmediatamente después de su publicación en la Plataforma. El
                uso continuado de la Plataforma después de dichas modificaciones
                constituye su aceptación de los nuevos Términos.
              </p>

              <p>
                Notificaremos cambios importantes a través del correo
                electrónico registrado o mediante un aviso prominente en la
                Plataforma.
              </p>
            </div>

            <div class="terms-section">
              <h2>9. Terminación</h2>
              <p>
                Podemos suspender o terminar su acceso a la Plataforma
                inmediatamente, sin previo aviso, por cualquier violación de
                estos Términos. Tras la terminación, su derecho a utilizar la
                Plataforma cesará inmediatamente.
              </p>

              <p>
                En caso de terminación por violación de estos Términos, no
                tendrá derecho a retirar Gemas pendientes.
              </p>
            </div>
          </div>

          <div class="info-box" style={{ marginBottom: 100 }}>
            <p>
              <strong>Recordatorio:</strong> Al utilizar CandyCam, usted
              confirma que ha leído, entendido y aceptado estos Términos de
              Servicio en su totalidad. Estos Términos constituyen el acuerdo
              completo entre usted y CandyCam con respecto al uso de la
              Plataforma.
            </p>
          </div>
        </div>
      </section>
    );
  }
}
